export default __webpack_public_path__ + "static/media/wrong.426074d2.svg";